//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentRequestRow from "./document-request-row";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRequestListBody",
  components: {
    DocumentRequestRow
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    sampleDocuments: {
      type: Array,
      required: true
    }
  }
});